module.exports = __webpack_public_path__ + "static/media/Warning.e854c4e4.jpg";